import React from 'react';
import {
  Card,
  Col,
  Modal,
  Row,
} from 'react-bootstrap';

import './index.scss';

export default function InstructionsModal({
  show,
  onHide,
}: {
  show: boolean,
  onHide: () => void,
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      className="confirmation-dialog-modal"
    >
      <Modal.Header
        closeButton
        className="confirmation-dialog-modal-header"
      >
        <Modal.Title className="ms-4">
          INSTRUÇÕES
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-5 seasonal-forecast-instructions">
        <Row>
          <Col md={6}>
            <Card className="shadow-sm forecast-instruction-card h-100">
              <Card.Header>COMO CONSULTAR PREVISÕES SAZONAIS</Card.Header>
              <Card.Body>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-text">
                    Para acessar as previsões, siga estes passos no
                    Painel de Controle (à direita):
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number">1</div>
                  <div className="instruction-text">
                    Escolha a variável de interesse (apenas uma por vez).
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number">2</div>
                  <div className="instruction-text">
                    Selecione um ou mais modelos climáticos disponíveis.
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number">3</div>
                  <div className="instruction-text">
                    Defina a área de plotagem para visualizar os dados.
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number">4</div>
                  <div className="instruction-text">
                    Escolha a data da rodada da previsão.
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number">5</div>
                  <div className="instruction-text">
                    Determine o período de seleção, que pode ser mensal
                    ou trimestral. No caso de trimestre, os períodos seguem o
                    formato JAN|FEV|MAR, FEV|MAR|ABR, MAR|ABR|MAI, etc.
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number">6</div>
                  <div className="instruction-text">
                    Se necessário, ative o contorno de bacias
                    hidrográficas ou as caixas de cálculo de
                    índices oceânicos na opção
                    {' '}
                    <b>&quot;Mostrar camadas&quot;</b>
                    .
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="shadow-sm forecast-instruction-card h-100">
              <Card.Header>COMO SALVAR SUAS PREFERÊNCIAS</Card.Header>
              <Card.Body>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-text">
                    Se você consulta sempre os mesmos dados, pode salvar suas
                    configurações para acesso rápido:
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number">1</div>
                  <div className="instruction-text">
                    Selecione todas as opções desejadas no Painel de Controle.
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number">2</div>
                  <div className="instruction-text">
                    Clique em
                    {' '}
                    <b>&quot;Salvar nova preferência&quot;</b>
                    .
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number instruction-marker">3</div>
                  <div className="instruction-text">
                    Escolha um nome descritivo para a sua configuração
                    (exemplo:
                    {' '}
                    <b>&quot;Previsão ENSO - Modelo ECMWF&quot;</b>
                    ).
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number instruction-marker">4</div>
                  <div className="instruction-text">
                    Suas preferências salvas estarão disponíveis para consulta futura.
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item">
                  <div className="instruction-number instruction-marker">5</div>
                  <div className="instruction-text">
                    Para redefinir a seleção, clique em
                    {' '}
                    <b>&quot;Limpar filtros&quot;</b>
                    .
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}
